import React from 'react';
import { Checkbox, Icon, Row, Col, Tooltip, Button, Modal } from 'antd'
import { dspxSorter } from '../helpers/dspx-sort';
import moment from 'moment';
import { actions as newDocumentActions } from '../actions/new-wdocument.actions'

const confirm = Modal.confirm;
export default class WarrantyDocument extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      checked: this.props.checked,
    }
  }

  handleDeleteDocument = d => {    

  if (!(d && d.id)) return

    confirm({
      title: 'Удалить документ?',
      content:
        <div>
          <div>{d.name}</div>
          {d.createDate 
            ? <div>от {moment(d.createDate).format('DD.MM.YYYY')}</div> 
            : null
          }
        </div>,

      onOk: () => {
        this.props.onDocumentDelete(d)
      },
      onCancel: () => {
        console.log('Cancel');
      },
    });
  }

  handleClick = d => {
    this.props.onDocumentClick(d.id,d.id+'_'+d.name+'.'+d.extension)
  }

  render() {
    const d = this.props.document
    const ic = d.direction === 'out' ? 'upload' : 'download'
    const cl = d.direction === 'out' ? '#00bd79' : '#ff9610'

    return <div className={`dspx-warranty-document`} style={{ padding: '5px 10px 5px 10px' }}
      onClick={()=>{this.handleClick(d)}}
      checked={this.state.checked}>

      <Row align='middle'>
        <Col span={22}>
          <Row>
            <Col span={1} >
              <Icon style={{ fontSize: '18px', margin: 0, color: cl }} type={ic} />
            </Col>
            <Col span={23} >
              <div >
                <span style={{ whiteSpace: 'nowrap', fontSize: '11px', color: '#888', marginLeft: '8px' }}> 
                  {d.docNumber || ''} 
                </span>
                <span style={{ whiteSpace: 'nowrap', fontSize: '11px', color: '#888', marginLeft: '0px' }}> 
                  {moment(d.createDate).format('DD.MM.YYYY')} 
                </span>
                <span style={{ whiteSpace: 'nowrap', fontSize: '12px', color: '#888', marginLeft: '8px' }}>
                  {d.createWorker.surName
                    + (d.createWorker.firstName ? (' ' + d.createWorker.firstName.substring(0, 1) + '.') : '')
                    + (d.createWorker.patrName ? (' ' + d.createWorker.patrName.substring(0, 1) + '.') : '')}
                </span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24} >
              <span style={{ whiteSpace: 'nowrap', fontSize: '11px', color: '#1aa0d6', marginLeft: '0px' }}>
                {d.organization && d.organization.inn}
              </span>
              <span style={{ marginLeft: '10px' }}>
                {d.organization && d.organization.name}
              </span>
              <span style={{ color: '#19867d', fontStyle:'italic', marginLeft: '8px' }}>
                 {d.organization && d.organization.directorFio} 
            </span>
            </Col>
          </Row>
          <Row>
            <Col span={24} >
              <span style={{ fontSize: '10px', color: '#bbb', marginRight: 10 }}>{d.type && d.type.name}</span>
              <span>{d.name}</span>
            </Col>
          </Row>
        </Col>

        <Col span={2} >
          {typeof this.props.onDocumentDelete === 'function' && (
            <Tooltip title="Удалить документ" placement="left">
              <Button
                shape="circle"
                icon="close-circle"
                className="dspx-warranty-document-delete-button"
                style={{ marginTop: 16 }}
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleDeleteDocument(d);
                }}
              />
            </Tooltip>
          )}
          
        </Col>
      </Row>

    </div>

  }
}
